(function () {
  "use strict";

  /* ---------- Carrossel do hero: pausa só enquanto pressionado ---------- */
  (function () {
    var pressedTrack = null;

    function press(e) {
      var strip = e.target.closest(".gg-hero__strip");
      if (!strip) return;
      var track = strip.querySelector(".gg-hero__track");
      if (!track) return;
      track.classList.add("is-paused");
      pressedTrack = track;
    }

    function release() {
      if (!pressedTrack) return;
      pressedTrack.classList.remove("is-paused");
      pressedTrack = null;
    }

    document.addEventListener("mousedown", press);
    document.addEventListener("touchstart", press, { passive: true });
    document.addEventListener("mouseup", release);
    document.addEventListener("touchend", release);
    document.addEventListener("touchcancel", release);
  })();

  /* ---------- Seletor de país/idioma: envia o form ao trocar ---------- */
  document.addEventListener("change", function (e) {
    var select = e.target.closest("[data-locale-autosubmit]");
    if (!select) return;
    select.closest("form").submit();
  });

  /* ---------- Menu mobile ---------- */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-menu-toggle]");
    if (!toggle) return;
    var header = toggle.closest("[data-header]");
    var nav = header && header.querySelector("[data-mobile-nav]");
    if (!nav) return;
    var open = nav.getAttribute("data-open") === "true";
    nav.setAttribute("data-open", open ? "false" : "true");
    toggle.setAttribute("aria-expanded", open ? "false" : "true");
  });

  /* ---------- Contador da sacola (sincroniza todos os data-cart-count) ---------- */
  function updateCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCart() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }
  window.gagosRefreshCart = refreshCart;

  /* ---------- Formulário de produto ---------- */
  function initProductForm(root) {
    var form = root.querySelector("[data-product-form]");
    if (!form) return;

    var variantsJson = root.querySelector("[data-variants-json]");
    var variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    var variantIdInput = form.querySelector('input[name="id"]');
    var buyBtns = root.querySelectorAll("[data-buy-now]");
    var priceEls = root.querySelectorAll("[data-product-price]");
    var comparePriceEl = root.querySelector("[data-product-compare-price]");
    var optionInputs = root.querySelectorAll("[data-option-selector]");

    function moneyFormat(cents) {
      return (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    }

    function findVariant(selected) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function currentSelection() {
      var groups = {};
      optionInputs.forEach(function (input) {
        if (input.type === "radio" && !input.checked) return;
        groups[input.dataset.optionPosition] = input.value;
      });
      var count = Object.keys(groups).length;
      var out = [];
      for (var i = 1; i <= count; i++) out.push(groups[i]);
      return out;
    }

    function setButtonState(variant) {
      buyBtns.forEach(function (buyBtn) {
        buyBtn.classList.remove("gg-btn--soldout", "gg-btn--empty");
        if (!variant) {
          buyBtn.disabled = true;
          buyBtn.textContent = buyBtn.dataset.labelEmpty;
          buyBtn.classList.add("gg-btn--empty");
          return;
        }
        if (!variant.available) {
          buyBtn.disabled = true;
          buyBtn.textContent = buyBtn.dataset.labelSoldout;
          buyBtn.classList.add("gg-btn--soldout");
          return;
        }
        buyBtn.disabled = false;
        buyBtn.textContent = buyBtn.dataset.labelDefault;
      });
    }

    function onSelectionChange() {
      var selected = currentSelection();
      var variant = findVariant(selected);

      if (variant) {
        variantIdInput.value = variant.id;
        priceEls.forEach(function (priceEl) { priceEl.textContent = moneyFormat(variant.price); });
        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = moneyFormat(variant.compare_at_price);
            comparePriceEl.style.display = "";
          } else {
            comparePriceEl.style.display = "none";
          }
        }
      } else {
        variantIdInput.value = "";
      }
      setButtonState(variant);
    }

    optionInputs.forEach(function (input) {
      input.addEventListener("change", onSelectionChange);
    });

    function addToCart(cb) {
      var variantId = variantIdInput.value;
      if (!variantId) return;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () {
          refreshCart();
          if (cb) cb();
        })
        .catch(function (err) {
          alert(err && err.description ? err.description : "Não foi possível adicionar ao carrinho.");
        });
    }

    buyBtns.forEach(function (buyBtn) {
      buyBtn.addEventListener("click", function (e) {
        e.preventDefault();
        if (buyBtn.disabled) return;
        addToCart(function () { window.location.href = "/checkout"; });
      });
    });

    var favBtn = root.querySelector("[data-favorite-toggle]");
    if (favBtn) {
      favBtn.addEventListener("click", function () {
        var pressed = favBtn.getAttribute("aria-pressed") === "true";
        favBtn.setAttribute("aria-pressed", pressed ? "false" : "true");
      });
    }

    onSelectionChange();
  }

  document.querySelectorAll("[data-product-root]").forEach(initProductForm);

  /* ---------- Carrinho: atualizar quantidade ---------- */
  document.addEventListener("change", function (e) {
    var input = e.target.closest("[data-cart-qty]");
    if (!input) return;
    var line = input.dataset.cartQty;
    var qty = parseInt(input.value, 10) || 0;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () { window.location.reload(); });
  });
})();
